// extracted by mini-css-extract-plugin
var _1 = "logoBox--TvE2MRve";
var _2 = "outsideContainer--c213_Nry";
export { _1 as "logoBox", _2 as "outsideContainer" }
